import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";
import { loadConfig } from "./config";
import { initTheme } from "./lib/theme";
import { App, createQueryClient } from "./App";

initTheme();

// Runtime config must be known before anything builds a URL.
void loadConfig().then((cfg) => {
  document.title = cfg.appName;
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App queryClient={createQueryClient()} />
    </StrictMode>,
  );
});
